<template>
  <div class="r-warning-modal">
    <BaseModalContent
      :name="name"
      :closable="false"
      :dynamic="true"
      @close="$emit('close')"
    >
      <div class="mb-m">
        <h2 class="r-warning-modal__title">Количество заявок превышено</h2>
        <p class="mb-m">
          По&nbsp;условиям конкурса вы&nbsp;можете участвовать только
          в&nbsp;одном мероприятии. Пожалуйста, выберите мероприятие
          в&nbsp;котором хотите приять участие
        </p>

        <div
          v-for="item in requests"
          :key="item.id"
          class="r-warning-modal__request"
        >
          <BaseRadio
            v-model="selectedRequestId"
            :value="item.id"
            :disabled="pending"
            name="reason"
            >{{ item.event.title || item.event.alt_title }}</BaseRadio
          >
        </div>
      </div>

      <div v-if="error">
        <p>При выборе мероприятия произошла ошибка</p>
        <p class="r-warning-modal__error">{{ error }}</p>
      </div>

      <div class="mt-l">
        <BaseButton
          :disabled="!selectedRequestId || pending"
          @click="rejectRequests"
          >Выбрать мероприятие</BaseButton
        >
      </div>
    </BaseModalContent>
  </div>
</template>

<script>
import { request } from "@/plugins/request";

export default {
  name: "RequestWarningModal",
  props: {
    requests: Array,
    confirmHandler: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      name: "request-warning-modal",
      selectedRequestId: null,
      pending: false,
      error: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  methods: {
    async cancelRequest(id) {
      await request({
        method: "PATCH",
        url: `/users/${this.user.id}/requests/${id}/reject/`,
        data: {
          rejected: true,
          rejection_reason: "Запланировано другое событие",
        },
      });
    },
    async rejectRequests() {
      this.pending = true;
      this.error = null;
      try {
        const requestForDelete = [...this.requests];
        const idx = requestForDelete.findIndex((req) => {
          return this.selectedRequestId === req.id;
        });
        if (idx >= 0) {
          requestForDelete.splice(idx, 1);
        }
        await Promise.all(
          requestForDelete.map((item) => {
            return this.cancelRequest(item.id);
          })
        );
        const selectedRequest = this.requests.find((itm) => {
          return itm.id === this.selectedRequestId;
        });
        this.confirmHandler(selectedRequest);
        this.$emit("close");
      } catch (error) {
        this.error = JSON.stringify(error?.response?.data);
      }
      this.pending = false;
    },
  },
};
</script>

<style lang="less" scoped>
.r-warning-modal {
  &__title {
    font-size: @font-size-h4;
    line-height: @line-height-h4;
    font-weight: bold;
    margin-bottom: @margin-l;
  }
  &__request {
    & + & {
      margin-top: @margin-s;
    }
  }
  &__error {
    color: @error-color;
  }
}
</style>
